import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ReportAnalysisService {
  private apiUrl: string;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`
      })
    };
  }

  analyzeReport(reportId: number) {
    return this.http.post<any>(
      `${this.apiUrl}/reports/${reportId}/analyze`,
      {},
      this.getAuthHeaders()
    );
  }

  listAnalyses(reportId: number) {
    return this.http.get<any>(
      `${this.apiUrl}/reports/${reportId}/analyses`,
      this.getAuthHeaders()
    );
  }

  compareReports(currentReportId: number, baselineReportId?: number) {
    return this.http.post<any>(
      `${this.apiUrl}/reports/compare`,
      {
        current_report_id: currentReportId,
        baseline_report_id: baselineReportId ?? null,
      },
      this.getAuthHeaders()
    );
  }

  analyzePhotoProgress(payload: {
    before_report_ids: number[];
    after_report_ids: number[];
    prescription_id?: number | null;
    chief_complaints?: string;
    diagnoses?: string;
    treatment_context?: string;
  }) {
    return this.http.post<any>(
      `${this.apiUrl}/reports/photo-progress`,
      payload,
      this.getAuthHeaders(),
    );
  }

  listPhotoProgressByPatient(patientId: number) {
    return this.http.get<any>(
      `${this.apiUrl}/reports/patient/${patientId}/photo-progress`,
      this.getAuthHeaders()
    );
  }

  treatmentOutcome(
    currentReportId: number,
    options: {
      prescriptionId?: number;
      baselineReportId?: number;
      consultContext?: {
        patient_id: number;
        appointment_id?: number;
        prescription_id?: number;
        chief_complaints?: string;
        prescription_blocks?: any[];
        treatment_duration?: string;
      };
    },
  ) {
    return this.http.post<any>(
      `${this.apiUrl}/reports/treatment-outcome`,
      {
        current_report_id: currentReportId,
        prescription_id: options.prescriptionId ?? null,
        baseline_report_id: options.baselineReportId ?? null,
        consult_context: options.consultContext ?? null,
      },
      this.getAuthHeaders()
    );
  }

  markerTrend(patientId: number, markerCode: string) {
    return this.http.get<any>(
      `${this.apiUrl}/reports/patient/${patientId}/marker-trend/${markerCode}`,
      this.getAuthHeaders()
    );
  }

  reviewAnalysis(analysisId: number, doctorOverrideNotes?: string) {
    return this.http.patch<any>(
      `${this.apiUrl}/reports/analyses/${analysisId}/review`,
      { doctor_override_notes: doctorOverrideNotes ?? null },
      this.getAuthHeaders()
    );
  }
}
